import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig() || {};

export const ALGOLIA_APP_ID = publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_APP;
export const ALGOLIA_TOKEN = publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_TOKEN;

export const ALGOLIA_INDEX_MAIN = publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_INDEX;
export const ALGOLIA_INDEX_QUERY_SUGGESTIONS =
    publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_QUERY_SUGGESTIONS;
export const ALGOLIA_INDEX_ID_PRODUCT_LIST = 'product-list';

export const ALGOLIA_INDEX_SORT_POPULAR = ALGOLIA_INDEX_MAIN;
export const ALGOLIA_INDEX_SORT_PRICE_ASC =
    publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_INDEX_PRICE_ASC;
export const ALGOLIA_INDEX_SORT_PRICE_DESC =
    publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_INDEX_PRICE_DESC;
export const ALGOLIA_INDEX_SORT_DISCOUNT_PERCENT_DESC =
    publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_INDEX_DISCOUNT_PERCENT_DESC;
export const ALGOLIA_INDEX_SORT_NEWEST_DESC =
    publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_INDEX_NEWEST_DESC;
export const ALGOLIA_INDEX_SORT_RATINGS_DESC =
    publicRuntimeConfig?.NEXT_PUBLIC_ALGOLIA_INDEX_RATINGS_DESC;
